export default __webpack_public_path__ + "static/media/total_sales.d7a7b2e0.svg";